import React, { useRef } from "react";
import { Rnd } from "react-rnd";
import { renderModulePlaceholder } from "../../helpers/meetingEditor.helper";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";

const ModuleWrapper = (props) => {
  const { name, position, size, onChange, module, selected, eventName, onSelect, template, deleted, gridLines, extra, preview, settings } = props;
  const { x, y, zIndex } = position;
  const { lockPosAndSize, show } = settings;
  const fullscreenRef = useRef();
  const gridBound = props.gridRef || document.getElementById("GridView");

  const onResize = (e, direction, ref, delta, position) => {
    let w, h;

    w = ((ref.offsetWidth / (gridBound.clientWidth + 2)) * 100).toString().substr(0, 8);

    h = ((ref.offsetHeight / (gridBound.clientHeight + 2)) * 100).toString().substr(0, 8);

    let yMargin = 0;
    let xMargin = 0;

    let y = (((position.y + yMargin) /* + 2 */ / gridBound.clientHeight) /* + 2 */ * 100).toString().substr(0, 8);
    let x = (((position.x + xMargin) /*  + 2 */ / gridBound.clientWidth) /* + 2 */ * 100).toString().substr(0, 8);

    if (y == undefined || !y || y < 0) y = 0;

    onChange({
      ...module,
      posX: x + "%",
      posY: y + "%",
      width: w + "%",
      height: h + "%",
    });
  };
  const onDragStop = (e, d) => {
    let y = ((d.y / gridBound.clientHeight) * 100).toString().substr(0, 4);
    let x = ((d.x / gridBound.clientWidth) * 100).toString().substr(0, 4);

    if (y == undefined || !y || y < 0) y = 0;

    onChange({
      ...module,
      posX: x + "%",
      posY: y + "%",
    });
  };
  const reCalcSizeToPixels = (size) => {
    let h, w;
    h = (parseFloat(size.height) / 100) * gridBound.clientHeight;
    w = (parseFloat(size.width) / 100) * gridBound.clientWidth;
    return { height: h, width: w };
  };
  const reCalcPositionToPixels = () => {
    let posX, posY;
    posX = (parseFloat(x) / 100) * gridBound.clientWidth;
    posY = (parseFloat(y) / 100) * gridBound.clientHeight;

    return { x: posX, y: posY };
  };
  const yInc = gridBound.clientHeight * 0.01;
  const xInc = gridBound.clientWidth * 0.01;
  const pos = reCalcPositionToPixels();
  const sz = reCalcSizeToPixels(size);
  if (deleted) return null;

  return (
    <Rnd
      className="module-wrapper"
      style={{ zIndex: show == false ? -100 : zIndex, opacity: show == false ? 0.5 : 1 }}
      bounds={".grid-view"}
      size={sz}
      disableDragging={!selected || preview || lockPosAndSize}
      enableResizing={selected && !preview && !lockPosAndSize}
      position={pos}
      dragGrid={gridLines ? [xInc, yInc] : [1, 1]}
      onDragStop={(e, d) => onDragStop(e, d)}
      onResize={(e, direction, ref, delta, position) => {
        if (!selected || preview) return;
        onResize(e, direction, ref, delta, position);
      }}
    >
      {!selected ? (
        <div className="m-frame" onClick={onSelect}></div>
      ) : (
        <div className="resizable">
          <div className="resizers">
            <div className="resizer top-left"></div>
            <div className="resizer top-right"></div>
            <div className="resizer bottom-left"></div>
            <div className="resizer bottom-right"></div>
          </div>
        </div>
      )}

      <div className="m-wrap" ref={fullscreenRef}>
        {deleted ? (
          <div className="card-item-wrapper deleted">
            <div className={`card-item-text deleted`}>
              <SystemLabel name="Deleted" />
            </div>
          </div>
        ) : null}
        {renderModulePlaceholder(
          name,
          template,
          {
            ...extra,
            width: size.width,
            height: size.height,
            bound: gridBound,
            eventName,
            layout: props.layout,
            fullscreenRef: fullscreenRef
          },
          settings,
          (settings) => props.updateModule({ ...module, settings })
        )}
        {/*        </EntranceAnimation> */}
      </div>
    </Rnd>
  );
};
export default ModuleWrapper;
